import React from 'react';

import {formatDate} from 'utils/datetime';

import rightStrike from './assets/tail-right.svg';

import './styles.css';

/*
We don't use <Link/> here because react router does not rerender the container content
The solution that is proposed from the docs does not work:
https://reacttraining.com/react-router/web/guides/dealing-with-update-blocking
*/

const BookingPeriod = ({start, end, bookingId, redirectToBookingDetail}) => (
  <div
    onClick={() => redirectToBookingDetail({bookingId})}
    className="BookingPeriod colab-clickable">
    <p className="start">{`Booking ${formatDate(start)}`}</p>
    <img src={rightStrike} alt="right strike" />
    <p className="end">{formatDate(end)}</p>
  </div>
);

export default BookingPeriod;
